import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button } from 'Components';
import { NotificationManager } from 'Components/Notifications';

import {
  clearRedux,
  deleteformSettings,
  searchFormSettings,
  openFormDelete
} from 'Redux/actions';


const FormDelete = (props) => {
  const dispatch = useDispatch();
  const { callBack } = props;
  const { messages } = useIntl();


  const {
    openDelete,
    formsDelete,
    responseDelete,
    loadingDelete,
    filters
  } = useSelector((state) => state.fsmSettingsRedux);



  useEffect(() => {
    if (responseDelete === true) {
      NotificationManager.success(
        messages['fsm_settings_form_delete_success'],
        messages['success'],
        3000,
        null,
        null,
        'Success',
      );

      dispatch(clearRedux("FSM_SETTINGS_FORM", {
        responseDelete: false,
        forms:[],
        response: {},
        form: {}
      }));
      handleClose();

    }
  }, [responseDelete]);


  const handleClose = useCallback(() => {
    dispatch(clearRedux("FSM_SETTINGS_FORM", {
      responseDelete: false,
      forms:[],
      response: {},
      form: {}
    }));
    callBack();
    dispatch(openFormDelete(false, []));
  });

  const handleCancel = useCallback(() => {
    dispatch(openFormDelete(false, []));
  });


  return (
    <Modal
      title={messages["fsm_settings_form_delete_title"]}
      open={openDelete}
      position="right"
      size="small"
      className="modal-top-0"
      headerStyle={{
        top: 0
      }}
      handleClose={handleCancel}
    >
      <ModalBody>
        <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>

          <div>
            <p>
              {messages["fsm_settings_form_delete_detail"]}
            </p>
            <p>
              {messages["fsm_settings_form_delete_warning"]}
            </p>
          </div>

          <div style={{ padding: 10 }}>
            <ul>
              {
                formsDelete
                &&
                formsDelete.map((form, index) => {
                  return (
                    <li key={index}>
                      <span>{form.name}</span>
                    </li>
                  )
                })
              }
            </ul>
          </div>

        </div>
      </ModalBody>

      <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }} >
        <Button
          disabled={loadingDelete}
          onClick={handleCancel}
          className="btn-cancel"
        >
          {messages['cancel']}
        </Button>

        <Button
          disabled={loadingDelete}
          onClick={(e) => {
            if (e) e.preventDefault();

            dispatch(deleteformSettings(formsDelete));
          }}
          className="btn-red"
        >
          {messages['delete']}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FormDelete;